(() => {
  const ALLOWED_FROM = [
    "/collections/private-sale",
    "/collections/private-sale-leather"
  ];

  const MAX_AGE_MS = 30 * 60 * 1000; // 30 minutos

  const toInt = (v) => {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : 0;
  };

  const isAllowedContext = () => {
    const active = sessionStorage.getItem("ps_active") === "1";
    if (!active) return false;

    const from = sessionStorage.getItem("ps_from") || "";
    const ts = toInt(sessionStorage.getItem("ps_ts"));
    const ageOk = ts && (Date.now() - ts) <= MAX_AGE_MS;
    const fromOk = ALLOWED_FROM.some(p => from.startsWith(p));

    return ageOk && fromOk;
  };

  // ❌ Si no vienes de Private Sale → fuera
  if (!isAllowedContext()) {
    ["ps_active", "ps_pct", "ps_from", "ps_ts"].forEach(k =>
      sessionStorage.removeItem(k)
    );
    return;
  }

  const ps = toInt(sessionStorage.getItem("ps_pct"));
  if (!ps) return;

  /* ======================
     Money helpers
  ====================== */

  const getMoneyFormat = () =>
    window.__ps_money_format ||
    window.money_format ||
    (window.Shopify && window.Shopify.money_format) ||
    "${{amount}}";

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, getMoneyFormat());
    }
    const n = (cents / 100).toFixed(2).replace(".", ",");
    return `${n} €`;
  };

  /* ======================
     Product data
  ====================== */

  const getProductJson = () => {
    const el = document.querySelector('script[id^="ProductJson-"]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  };

  const getVariantId = () => {
    const input = document.querySelector(
      "form[action*='/cart/add'] input[name='id']"
    );
    if (input) return toInt(input.value);

    const q = new URLSearchParams(location.search).get("variant");
    return q ? toInt(q) : 0;
  };

  const getVariantPrice = (variantId) => {
    const pj = getProductJson();
    if (!pj || !Array.isArray(pj.variants)) return 0;

    const v =
      pj.variants.find(v => toInt(v.id) === variantId) ||
      pj.variants.find(v => v.available) ||
      pj.variants[0];

    return toInt(v?.price);
  };

  /* ======================
     DOM helpers
  ====================== */

  const metasRoot = () =>
    document.querySelector(".product-single__metas") ||
    document.querySelector(".bwp-single-info") ||
    document.body;

  const findNativePrice = () => {
    const root = metasRoot();
    return (
      root.querySelector(".price-container") ||
      root.querySelector(".product-single__price") ||
      root.querySelector(".product__price") ||
      root.querySelector(".price")
    );
  };

  const hideNativePrice = () => {
    const p = findNativePrice();
    if (!p || p.classList.contains("ps-price")) return;
    p.style.setProperty("display", "none", "important");
  };

  const ensurePsNode = () => {
    let node = document.querySelector(".ps-price.ps-product");
    if (node) return node;

    node = document.createElement("div");
    node.className = "ps-price ps-product";
    node.style.display = "flex";
    node.style.gap = "10px";
    node.style.alignItems = "baseline";

    const regular = document.createElement("div");
    regular.className = "product-price product-price--regular";
    regular.innerHTML = "<s></s>";

    const sale = document.createElement("div");
    sale.className = "product-price price-sale";

    node.appendChild(regular);
    node.appendChild(sale);

    const native = findNativePrice();
    if (native) {
      native.insertAdjacentElement("afterend", node);
    } else {
      metasRoot().prepend(node);
    }

    return node;
  };

  /* ======================
     Render
  ====================== */

  const render = () => {
    const variantId = getVariantId();
    const base = getVariantPrice(variantId);
    if (!base) return;

    const final = Math.round((base * (100 - ps)) / 100);

    hideNativePrice();

    const node = ensurePsNode();
    node.querySelector("s").textContent = formatMoney(base);
    node.querySelector(".price-sale").textContent = formatMoney(final);
  };

  const boot = () => {
    render();

    // Cambios de variante
    const input = document.querySelector(
      "form[action*='/cart/add'] input[name='id']"
    );

    if (input) {
      const obs = new MutationObserver(render);
      obs.observe(input, { attributes: true, attributeFilter: ["value"] });
      input.addEventListener("change", render);
    }

    // El tema suele repintar el precio
    const root = metasRoot();
    if (root) {
      const obs2 = new MutationObserver(render);
      obs2.observe(root, { childList: true, subtree: true });
    }

    setTimeout(render, 600);
    setTimeout(render, 1400);
    setTimeout(render, 2400);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();